<template>
  <!-- 工单详情-工艺单部分 -->
  <div>
    <el-table
      :data="craftOrder.craftItems"
      class="craft-order"
      :row-style="{ height: '0' }"
      :cell-style="{ padding: '0px' }"
      :header-cell-style="{ padding: 0 }"
      border
    >
      <el-table-column label="梳号" prop="combSection" align="center" />
      <el-table-column label="条数" prop="headVeins" align="center" />
      <el-table-column label="盘头数" prop="panHeadNum" align="center" />
      <el-table-column label="送经量" prop="sendYarnFeed" align="center" />
      <el-table-column label="工艺组织" prop="organization" align="center" />
      <el-table-column label="穿纱方式" prop="crossYarnWay" align="center" />
      <el-table-column label="备注" prop="remark" align="center" />
      <el-table-column label="批号" prop="materialBatch" align="center" />
      <el-table-column label="供应商" prop="provider" align="center" />
      <el-table-column label="计划用量" prop="planLength" align="center" />
      <el-table-column label="D数" align="center">
        <template slot-scope="scope">{{ scope.row.dcount / 100 }}</template>
      </el-table-column>
      <el-table-column label="牵伸" align="center">
        <template slot-scope="scope">{{ scope.row.stretchRate / 100 }}</template>
      </el-table-column>
      <el-table-column label="占比" prop="percent" align="center" />
      <el-table-column label="物料名称" prop="materialName" align="center" />
      <el-table-column
        label="规格名称"
        prop="materialStandard"
        align="center"
      />
      <el-table-column label="物料编号" prop="materialNumber" align="center" />
      <el-table-column label="单位" prop="unit" align="center" />
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      craftOrder: {
        name: "",
        craftRemarks: "",
        craftItems: [],
      },
      // craftItemKeys: {
      //   combSection: { value: "梳号", width: 40 },
      //   headVeins: { value: "条数", width: 60 },
      //   panHeadNum: { value: "盘头数", width: 80 },
      //   sendYarnFeed: { value: "送经量", width: 80 },
      //   organization: { value: "工艺组织", width: 220 },
      //   crossYarnWay: { value: "穿纱方式", width: 150 },
      //   remark: { value: "备注", width: 100 },
      //   materialBatch: { value: "批号", width: 60 },
      //   provider: { value: "供应商", width: 80 },
      //   planLength: { value: "计划用量", width: 80 },
      //   dcount: { value: "D数", width: 40 },
      //   stretchRate: { value: "牵伸", width: 40 },
      //   percent: { value: "占比", width: 40 },
      //   materialName: { value: "物料名称", width: 100 },
      //   materialStandard: { value: "规格名称", width: 100 },
      //   materialNumber: { value: "物料编号", width: 100 },
      //   unit: { value: "单位", width: 30 },
      // },
    };
  },
  methods: {
    // 设置工艺单信息
    setCraftOrder(rsponse) {
      this.craftOrder = rsponse;
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.table-input {
  width: 100%;
  height: 30px;
  border: 0px;
  outline: none;
  padding: 0;
  margin: 0;
  text-align: center;
}
.el-button {
  margin: 6px 10px 0px 0px;
}
</style>
